<template>
  <b-sidebar position="absolute"
              :right="true"
              :fullheight="true"
              :overlay="false"
              :open="activeSidebar === 'edit-group-template' && formGroupTemplate !== null">
    <div class="vikingsidebar" v-if="formGroupTemplate !== null">
      <div class="vikingsidebar__field">
        <div class="vikingsidebar__field__header">
          <h3>Opsætning ({{ this.allocations.length }})</h3>
        </div>
      </div>

      <div class="vikingsidebar__field" key="10">
        <div class="vikingsidebar__field__label">Navn</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.title"
                   @input="(value) => templatePropertyChanged({propertyName: 'title', value})"
                   type="text"></b-input>
        </div>
      </div>

      <div class="vikingsidebar__field" key="20">
        <div class="vikingsidebar__field__label">Manuel planlægning</div>
        <div class="vikingsidebar__field__input">
          <div class="fake-control">
            <b-switch :value="formGroupTemplate.isTemplateManual"
                      @input="(value) => templatePropertyChanged({propertyName: 'isTemplateManual', value})"
                      type="is-primary"
                      size="is-medium">{{ formGroupTemplate.isTemplateManual ? 'Ja' : 'Nej' }}</b-switch>
          </div>
        </div>
      </div>      

      <div class="vikingsidebar__field" key="30">
        <div class="vikingsidebar__field__label">Dato fra</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.fromDate"
                   @input="(value) => templatePropertyChanged({propertyName: 'fromDate', value})"
                   type="date"></b-input>
        </div>
      </div>

      <div class="vikingsidebar__field" key="40" v-if="formGroupTemplate.isTemplateManual === false">
        <div class="vikingsidebar__field__label">Dato til</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.toDate"
                   @input="(value) => templatePropertyChanged({propertyName:'toDate', value})"
                   type="date"></b-input>
        </div>
      </div>

      <div class="vikingsidebar__field" key="50">
        <div class="vikingsidebar__field__label">Hverdage</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.atWorkWeekDays"
                   @input="(value) => templatePropertyChanged({propertyName: 'atWorkWeekDays', value})"
                   type="number"></b-input>
        </div>
      </div>
            
      <div class="vikingsidebar__field" key="60">
        <div class="vikingsidebar__field__label">Lørdage</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.atWorkWeekSaturday"
                   @input="(value) => templatePropertyChanged({propertyName: 'atWorkWeekSaturday', value})"
                   type="number"></b-input>
        </div>
      </div>

      <div class="vikingsidebar__field" key="70">
        <div class="vikingsidebar__field__label">Søndage</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.atWorkWeekSunday"
                   @input="(value) => templatePropertyChanged({propertyName: 'atWorkWeekSunday', value})"
                   type="number"></b-input>
        </div>
      </div>
        
      <div class="vikingsidebar__field" key="80">
        <div class="vikingsidebar__field__label">Helligdag hverdage</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.atWorkHolidayWeekdays"
                   @input="(value) => templatePropertyChanged({propertyName: 'atWorkHolidayWeekdays', value})"
                    type="number"></b-input>
        </div>
      </div>
        
      <div class="vikingsidebar__field" key="90">
        <div class="vikingsidebar__field__label">Helligdag weekend</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.atWorkHolidayWeekend"
                   @input="(value) => templatePropertyChanged({propertyName: 'atWorkHolidayWeekend', value})"
                   type="number"></b-input>
        </div>
      </div>

      <div class="vikingsidebar__field" key="100" v-if="formGroupTemplate.isTemplateManual">
        <div class="vikingsidebar__field__label">Uger planlagt</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.planningWeeks"
                   @input="(value) => templatePropertyChanged({propertyName: 'planningWeeks', value})"
                   type="number"></b-input>
        </div>
      </div>
        
      <div class="vikingsidebar__field" key="110" v-if="formGroupTemplate.isTemplateManual">
        <div class="vikingsidebar__field__label">Antal gentagelser</div>
        <div class="vikingsidebar__field__input">
          <b-input v-model="formGroupTemplate.repeatWeeks"
                   @input="(value) => templatePropertyChanged({propertyName: 'repeatWeeks', value})"
                   type="number"></b-input>
        </div>
      </div>

      <div class="vikingsidebar__field" key="120" v-if="formGroupTemplate.isTemplateManual === false">
        <div class="vikingsidebar__field__label">Sammenhængende fridage</div>
        <div class="vikingsidebar__field__input">
          <b-input :value="formGroupTemplate.daysFreeInRow"
                   @input="(value) => templatePropertyChanged({propertyName: 'daysFreeInRow', value})"
                   type="number"></b-input>
        </div>
      </div>

      <div class="vikingsidebar__field" key="130" v-if="formGroupTemplate.isTemplateManual === false">
        <div class="vikingsidebar__field__label">Dynamisk planlægning</div>
        <div class="vikingsidebar__field__input">
          <div class="fake-control">
            <b-switch :value="formGroupTemplate.isTemplateDynamic"
                      @input="(value) => templatePropertyChanged({propertyName: 'isTemplateDynamic', value})"
                      type="is-primary"
                      size="is-medium">{{formGroupTemplate.isTemplateDynamic ? 'Ja' : 'Nej'}}</b-switch>
          </div>
        </div>
      </div>

      <div class="vikingsidebar__field" key="140" v-if="formGroupTemplate.isTemplateDynamic && formGroupTemplate.isTemplateManual === false">
        <div class="vikingsidebar__field__label">Lørdag er en del af weekend gruppen</div>
        <div class="vikingsidebar__field__input">
          <div class="fake-control">
            <b-switch :value="formGroupTemplate.isSaturdayWeekendGroup"
                      @input="(value) => templatePropertyChanged({propertyName: 'isSaturdayWeekendGroup', value})"
                      type="is-primary"
                      size="is-medium">{{formGroupTemplate.isSaturdayWeekendGroup ? 'Ja' : 'Nej'}}</b-switch>
          </div>
        </div>
      </div>

      <div class="vikingsidebar__field" key="140">
        <div class="vikingsidebar__field__label">Slet</div>
        <div class="vikingsidebar__field__input">
          <div class="fake-control">
            <b-switch :value="formGroupTemplate.isDeleted"
                      @input="(value) => templatePropertyChanged({propertyName: 'isDeleted', value})"
                      type="is-primary"
                      size="is-medium">{{formGroupTemplate.isDeleted ? 'Ja' : 'Nej'}}</b-switch>
          </div>
        </div>
      </div>

      <div class="vikingsidebar__spacer" />

      <div class="vikingsidebar__footer">          
        <div class="vikingsidebar__footer__controls">
          <div class="vikingsidebar__footer--item">
            <b-button @click="sidebarBtn_updateGroupTemplate" class="is-blue">Gem ændringer</b-button>
          </div>
          <div class="vikingsidebar__footer--item">
            <b-button @click="sidebarBtn_cancel" class="is-text">Annuller</b-button>
          </div>
        </div>
        <div class="vikingsidebar__footer__update">
          {{ latestUpdateTextFormGroupTemplate }}
        </div>
      </div>
    </div>

  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'group-template-edit-sidebar',
  props: {
    fromDate: {
      type: String
    },
    groupFilter: {
      type: String
    }
  },
  computed: {
    ...mapGetters('statisticsStore', [
      'allocations',
      'activeSidebar',
      'formGroupTemplate',
      'latestUpdateTextFormGroupTemplate'
    ]),

  },
  methods: {
    ...mapActions('statisticsStore', [
      'updateGroupTemplate',
      'setFormGroupTemplate',
      'closeGroupTemplateSidebars',
      'applyGroupTemplate',
      'templatePropertyChanged',

    ]),
    async sidebarBtn_updateGroupTemplate() {
      const selectedDate = await this.updateGroupTemplate({fromDate: this.fromDate, groupFilter: this.groupFilter});
      this.$emit('selected-date', selectedDate);
    },
    sidebarBtn_cancel() {
      this.closeGroupTemplateSidebars();
      this.setFormGroupTemplate(null);
    },
    async sidebarBtn_applyGroupTemplate() {
      await this.applyGroupTemplate(this.groupFilter);
    },

  }
}
</script>
<style lang="scss">

</style>
